import axios from 'axios';
import { getLinkToSubdomain } from 'components/subdomainLinkString';

const getBuilderApiBaseUrl = shopName => getLinkToSubdomain(shopName, `/api/builder`, true);

// THEME_BUILDER
export const initThemeCacheAction = ({ shopName, body }) => () => axios.post(getBuilderApiBaseUrl(shopName), body);

export const initThemeTemplateCacheAction = ({ shopName, cacheId, body }) => () => axios.post(`${getBuilderApiBaseUrl(shopName)}/${cacheId}`, body);

export const updateThemeCacheAction = ({ shopName, cacheId, body }) => () => axios.patch(`${getBuilderApiBaseUrl(shopName)}/${cacheId}`, body);

export const deleteThemeCacheAction = ({ shopName, cacheId }) => () => axios.delete(`${getBuilderApiBaseUrl(shopName)}/${cacheId}`);

export const getThemeFontsAction = ({ shopName }) => () => axios.get(`${getBuilderApiBaseUrl(shopName)}/fonts`);
